import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import ErrorMessage from './ErrorMessage';

const ErrorMessageBridge = react2angular(ErrorMessage, ['message']);

export default ErrorMessageBridge;
